import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router';

import { format, parseISO, parse } from 'date-fns';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import * as Yup from 'yup';
import { useToast } from '../../hooks/toast';
import api from '../../services/api';
import { sexo, estados } from './dados';

import { Container, Box, LineForm } from './styles';

import Input from '../../components/Exame/InputExame';
import DatePicker from '../../components/Exame/DatePicker';
import SelectSync from '../../components/Exame/SelectSync';
import ItemExame from '../../components/ItemExame';
import Disappearedloading from '../../components/Loading';

import RecuperaAdicionais from '../../components/ItemExame/RecuperaAdicionais';
import getValidationErrors from '../../utils/getValidationErrors';

interface IExameInfo {
  id: number;
  ExaAgeCodigo: number;
  ExaPacCodigo: number;
  ExaPacNome: string;
  ExaPacSexo: string;
  ExaPacDataNasc: Date | null;
  ExaData: Date | null;
  ExaHora: Date | null;
  ExaObservacao: string;
  ExaMedNome: string;
  ExaMedCRM: string;
  ExaMedUF: string;

  ExaCodigoLis: Date | null;
  age: number;
}
export interface IExamesAlvaro {
  Codigo: string;
  Nome: string;
  Material: string;
  DadoObrigatorio: string;
  CodigoAMB: string;
  DataAtualizacao: string;
  EhCurva: string;
  EhDescritivo: string;
  ListaMaterial: string;
}

export interface IExameItem {
  id: number;
  ItmExaCodigo: string;
  ItmMaterial: string;
  ItmCodigoBarras: string;
  ItmIdentificacao: string;
  ItmDadosAdicionais: string;
  ItmExaUrgente: boolean | null;
  Exame_id: number;
  ItmExaQtde: number;
  ItmExaObservacao: string;
  ItmStatus: string;
  ItmCurva: string;
  ItmEhCurva: string;
  ItmTemDados: string;
  examesAlvaro?: IExamesAlvaro;
  ItmListaMaterial: string;
  dataAtualizacao?: Date;
}
// ListaMaterial: "{\"ItmExaCodigo\":\"HDL\",\"ItmMaterial\":[{\"value\":\"543\",\"label\":\"543 - soro\"}]}"
interface IExame {
  id: number;
  ExaAgeCodigo: number;
  ExaPacCodigo: number;
  ExaPacNome: string;
  ExaPacSexo: string;
  ExaData: string;
  ExaHora: string;
  ExaPacDataNasc: string;
  ExaMedNome: string;
  ExaMedCRM: string;
  ExaMedUF: string;
  ExaCodigoLis: string;
  ExaCodOS: string;
  ExaObservacao: string;
  ExaIncluido: boolean;
  ExaBaseBarras: string;
  ExaUsuCodigo: number;
  ExaLink: string;
  ExaCliCodigo: string;
  exameItens: IExameItem[];
}

const Exame: React.FC = () => {
  //  const dispatch = useDispatch();
  // const statusExames = useSelector(state => state.status.statusExames);

  function useQuery(): URLSearchParams {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(true);
  const [status, setStatus] = useState('Confirmar');
  const [exames, setExames] = useState<IExameItem[]>([]);
  const [validado, setValidado] = useState(false);
  const [statusExames, setStatusExames] = useState<{ [key: number]: string }>(
    {},
  );
  const [id, setId] = useState<string | null>(null);
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();

  const calcularIdade = useCallback((aniversario: string): number => {
    const dataNascimento = parse(
      format(parseISO(aniversario), 'yyyy-MM-dd'),
      'yyyy-MM-dd',
      new Date(),
    );

    const diferenca = Date.now() - dataNascimento.getTime();
    const idade = new Date(diferenca); // miliseconds from epoch
    return Math.abs(idade.getUTCFullYear() - 1970);
  }, []);

  const AlteraStatusExame = useCallback(
    (idExame: number, statusAtual: string) => {
      let valido = false;
      setStatusExames(state => {
        const statusAlterado = state;
        statusAlterado[idExame] = statusAtual;

        valido = Object.keys(statusAlterado).every((ex: string) => {
          return (
            statusAlterado[Number(ex)] === 'Confirmado' ||
            statusAlterado[Number(ex)] === 'Excluido'
          );
        });
        setValidado(valido);
        return statusAlterado;
      });
    },
    [],
  );

  useEffect(() => {
    setId(query.get('id'));
  }, [query]);

  useEffect(() => {
    exames.map(item => {
      AlteraStatusExame(item.id, item.ItmStatus);
      return {
        [item.id]: item.ItmStatus,
      };
    });
  }, [exames, AlteraStatusExame]);

  useEffect(() => {
    async function loadExame(): Promise<void> {
      setLoading(true);
      try {
        const retorno = await api.get<IExame>(`exame/?id=${id}`); // ${query}`);
        // console.log(retorno.data);
        if (retorno.data === null) {
          setLoading(false);
          setStatus('Incluido');
          addToast({
            type: 'info',
            title: 'Exame não encontrado',
          });
          return;
        }

        const ex: IExameInfo = {
          id: Number(id),
          ExaAgeCodigo: retorno.data.ExaAgeCodigo,
          ExaPacCodigo: retorno.data.ExaPacCodigo,
          ExaPacNome: retorno.data.ExaPacNome,
          ExaPacSexo: retorno.data.ExaPacSexo,
          ExaData: retorno.data.ExaData
            ? parse(
                format(parseISO(retorno.data.ExaData), 'yyyy-MM-dd'),
                'yyyy-MM-dd',
                new Date(),
              )
            : null,
          ExaPacDataNasc: retorno.data.ExaPacDataNasc
            ? parse(
                format(parseISO(retorno.data.ExaPacDataNasc), 'yyyy-MM-dd'),
                'yyyy-MM-dd',
                new Date(),
              )
            : null,
          ExaHora: retorno.data.ExaHora
            ? parse(
                format(parseISO(retorno.data.ExaHora), 'HH:mm'),
                'HH:mm',
                new Date(),
              )
            : null,
          ExaCodigoLis: retorno.data.ExaCodigoLis
            ? parse(
                format(parseISO(retorno.data.ExaCodigoLis), 'yyyy-MM-dd'),
                'yyyy-MM-dd',
                new Date(),
              )
            : null,
          age: calcularIdade(retorno.data.ExaPacDataNasc),
          ExaObservacao: retorno.data.ExaObservacao,
          ExaMedUF:
            retorno.data.ExaMedUF && retorno.data.ExaMedUF !== ''
              ? retorno.data.ExaMedUF
              : 'RJ',
          ExaMedNome: retorno.data.ExaMedNome,
          ExaMedCRM: retorno.data.ExaMedCRM,
        };

        formRef.current?.setData(ex);
        if (retorno.data.ExaIncluido === true) {
          setStatus('Incluido');
        }

        const itmEx: IExameItem[] = retorno.data.exameItens.map(item => {
          let adic = {};

          if (item.ItmDadosAdicionais !== '') {
            const dadosad = item.ItmDadosAdicionais.split('@carac#xA;');

            dadosad.forEach(cp => {
              adic = { ...adic, ...RecuperaAdicionais(cp) };
            });
          }

          return {
            id: item.id,
            ItmExaCodigo: item.ItmExaCodigo,
            ItmMaterial: item.ItmMaterial,
            ItmCodigoBarras: item.ItmCodigoBarras,
            ItmIdentificacao: item.ItmIdentificacao,
            ItmDadosAdicionais: item.ItmDadosAdicionais,
            ItmExaUrgente: item.ItmExaUrgente,
            Exame_id: item.Exame_id,
            ItmNome: item.examesAlvaro ? item.examesAlvaro.Nome : '',
            ItmExaQtde: item.ItmExaQtde === 0 ? 1 : item.ItmExaQtde,
            ItmExaObservacao: item.ItmExaObservacao,
            ItmStatus: item.ItmStatus, // 'Confirmar', // Confirmar, Confirmado, Excluído
            ItmEhCurva: String(
              item.examesAlvaro ? item.examesAlvaro.EhCurva === 'S' : 'N',
            ),
            ItmCurva: item.ItmCurva,
            ItmTemDados: item.examesAlvaro
              ? item.examesAlvaro.DadoObrigatorio
              : '',
            ItmListaMaterial: item.examesAlvaro
              ? item.examesAlvaro.ListaMaterial
              : '',
            ...adic,
            dataAtualizacao: item.examesAlvaro?.DataAtualizacao
              ? parseISO(item.examesAlvaro?.DataAtualizacao)
              : undefined,
          };
        });

        setExames(itmEx);
        setLoading(false);
      } catch (error: any) {
        setLoading(false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.status
        ) {
          addToast({
            type: 'error',
            title: error.response.data.message,
          });
        } else {
          addToast({
            type: 'error',
            title: 'Ocorreu um erro desconhecido!',
          });
        }

        /* setTimeout(() => {
               window.location = `https://agendafacilsp.med.br/AgendaAtendimento?Agenda=${agenda}`;
            }, 3000); */
      }
    }
    // ${query}`);
    if (!id) return;

    if (id) loadExame();
  }, [addToast, calcularIdade, id]);

  const handleSubmit = useCallback(
    async (data: IExameInfo): Promise<void> => {
      setLoading(true);
      if (!editing) {
        setEditing(true);
        setLoading(false);
        setStatus('Confirmar');
        return;
      }

      try {
        // Remove all previous errors
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          ExaPacNome: Yup.string().required('Nome do Paciente obrigatório'),
          ExaPacDataNasc: Yup.date().required('Data de Nascimento obrigatório'),
          ExaPacSexo: Yup.string().required('Campo Sexo obrigatório'),
          ExaData: Yup.date().required('Data de Coleta obrigatório'),
          ExaHora: Yup.date().required('Hora de Coleta obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await await api.put(`exame/${query.get('id')}`, {
          ExaData: data.ExaData,
          ExaHora: data.ExaHora,
          ExaObservacao: data.ExaObservacao,
          ExaMedNome: data.ExaMedNome,
          ExaMedCRM: data.ExaMedCRM.trim(),
          ExaMedUF: data.ExaMedUF,
        });
        setStatus('Confirmado');
        setEditing(false);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRef.current?.setErrors(errors);
        } else {
          addToast({
            type: 'error',
            title: `Ocorreu um erro so salvar dados${error}`,
          });
        }
        setLoading(false);
      }
    },
    [addToast, editing, query],
  );

  const enviaSolicitacaoLis = useCallback(async () => {
    setLoading(true);
    // console.log('Enviou LIS');
    try {
      const retorno = await api.get(`exame/examesimples/${query.get('id')}`);

      // console.dir(retorno);
      if (!retorno.data.incluido) {
        setLoading(false);
        if (retorno.data.mensagem) {
          addToast({
            type: 'error',
            title: retorno.data.mensagem,
          });
          return;
        }
        addToast({
          type: 'error',
          title: 'Ocorreu um erro desconhecido ao buscar dados',
        });
        return;
      }
      addToast({
        type: 'success',
        title: `Solicitacao Enviada com sucesso`,
      });
      setStatus('Incluido');
      window.history.go(-2);
      // window.location = document.getElementById('HidUrlAgenda')?.value || '';
    } catch (err) {
      addToast({
        type: 'error',
        title: `Ocorreu um erro so salvar dados${err}`,
      });
    }
    setLoading(false);
  }, [addToast, query]);

  return (
    <Container>
      <input type="hidden" value="something" />
      <h2>Exames - Cadastrar Ordem de Serviço</h2>
      {loading ? <Disappearedloading /> : ''}
      <Form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
        <Box>
          <LineForm>
            <h2>Dados do Paciente</h2>
          </LineForm>
          <LineForm>
            <div style={{ width: '40%' }}>
              <Input
                label="Nome do paciente *"
                type="text"
                name="ExaPacNome"
                placeholder="Nome do paciente *"
                maxLength={60}
                id="ExaPacNome"
                disabled
              />
            </div>
            <div style={{ display: 'grid', height: '14px', width: '12%' }}>
              <DatePicker
                className="react-datepicker__input-container"
                id="ExaPacDataNasc"
                name="ExaPacDataNasc"
                maxLength={10}
                dateFormat="dd/MM/yyyy"
                type="text"
                placeholder="Data de nascimento *"
                label="Data de nascimento *"
                disabled
              />
            </div>
            <div style={{ width: '4%' }}>
              <Input
                type="text"
                name="age"
                disabled
                placeholder="Idade"
                label="Idade"
                maxLength={3}
                id="age"
              />
            </div>
            <div style={{ display: 'grid', height: '14px', width: '10%' }}>
              <SelectSync
                name="ExaPacSexo"
                id="ExaPacSexo"
                options={sexo}
                placeholder="Sexo"
                label="Sexo"
                isDisabled
              />
            </div>
            <div style={{ width: '22%' }}>
              <Input
                type="text"
                name="osIdLis"
                placeholder="Código OS LIS"
                label="Código OS LIS"
                maxLength={30}
                id="osIdLis"
              />
            </div>
          </LineForm>
          <LineForm>
            <div style={{ width: '16%' }}>
              <Input
                type="text"
                name="idLis"
                placeholder="Código do paciente (ID LIS)"
                label="Código do paciente (ID LIS)"
                maxLength={20}
                id="idLis"
              />
            </div>
            <div style={{ display: 'grid', height: '14px', width: '12%' }}>
              <DatePicker
                type="text"
                placeholder="Data da coleta"
                label="Data da coleta"
                id="ExaData"
                name="ExaData"
                dateFormat="dd/MM/yyyy"
                className="react-datepicker__input-container"
                disabled={!editing}
              />
            </div>
            <div style={{ width: '9%' }}>
              <DatePicker
                type="text"
                placeholder="Hora da coleta"
                label="Hora da coleta"
                id="ExaHora"
                name="ExaHora"
                showTimeSelect
                showTimeSelectOnly
                dateFormat="HH:mm"
                timeIntervals={15}
                className="react-datepicker__input-container"
                disabled={!editing}
              />
            </div>
            <div style={{ width: '33%' }}>
              <Input
                type="text"
                name="ExaMedNome"
                placeholder="Médico"
                label="Médico"
                maxLength={40}
                id="ExaMedNome"
              />
            </div>
            <div style={{ width: '14%' }}>
              <Input
                type="text"
                name="ExaMedCRM"
                placeholder="CRM"
                id="ExaMedCRM"
                label="CRM"
                maxLength={8}
              />
            </div>
            <div style={{ display: 'grid', height: '14px', width: '8%' }}>
              <SelectSync
                name="ExaMedUF"
                id="ExaMedUF"
                options={estados}
                placeholder="Estado"
                label="Estado"
              />
            </div>
          </LineForm>
          <LineForm>
            <div style={{ width: '85%' }}>
              <Input
                name="ExaObservacao"
                placeholder="Observação"
                id="ExaObservacao"
                label="Observação"
                maxLength={250}
                type="text"
                disabled={!editing}
              />
            </div>

            <div
              style={{
                width: '13%',
                display: status === 'Incluido' ? 'none' : 'inherit',
              }}
            >
              <button className={`submit ${status}`} type="submit">
                {loading ? 'Carregando' : status}
              </button>
            </div>
          </LineForm>
          <Input type="hidden" name="id" id="id" />
        </Box>
      </Form>
      {exames &&
        exames.length > 0 &&
        exames.map(ex => (
          <ItemExame
            key={`item${ex.ItmExaCodigo}`}
            setStatusExame={AlteraStatusExame}
            Item={ex}
          />
        ))}
      <LineForm />
      <div id="botoes" className="md-layout orders-new__footer">
        <div id="botoesInicio" className="md-layout md-align-start">
          <div className="md-flex-40">
            {/* <a
              href="#"
              id="btnCancelar"
              className="btn btn-medium btn-septenary orders-new__exam__-button"
              rel="noopener noreferrer"
            > */}
            <span>Cancelar (link voltar para lista)</span>
          </div>
        </div>
        <div
          id="botoesFim"
          className={`md-layout endButton md-align-end md-flex-40 ${
            validado && status === 'Confirmado'
          }`}
        >
          <button
            onClick={enviaSolicitacaoLis}
            type="button"
            id="btnSalvar"
            className="btn btn-medium btn-primary orders-new__exam__-button"
            disabled={loading}
          >
            {loading ? 'Carregando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </Container>
  );
};

export default Exame;
